import { render, staticRenderFns } from "./partner.vue?vue&type=template&id=f31adf88&scoped=true&"
import script from "./partner.vue?vue&type=script&lang=js&"
export * from "./partner.vue?vue&type=script&lang=js&"
import style0 from "./partner.vue?vue&type=style&index=0&id=f31adf88&prod&lang=css&"
import style1 from "./partner.vue?vue&type=style&index=1&id=f31adf88&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f31adf88",
  null
  
)

export default component.exports